// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss } from "@awc/XDL/Utilities/mergeWithCss";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";

interface OwnProps {
    leftTitle?: string;
    extraColHeader?: string;
    rightTitles?: string[];
    extendedStyles?: LinesHeaderStyles;
    showBorderBottom?: boolean;
    includeRightAction?: boolean;
    showExtraCol?: boolean;
}

export interface LinesHeaderStyles {
    wrapper?: InjectableCss;
    itemDescription?: InjectableCss;
    rightSection?: InjectableCss;
    qty?: InjectableCss;
    priceUnit?: InjectableCss;
    total?: InjectableCss;
    extraCol?: InjectableCss;
    titleText?: TypographyPresentationProps;
}

export const linesHeaderStyles: LinesHeaderStyles = {};
export const linesHeaderExtraColStyles: LinesHeaderStyles = {};

const LinesHeader = ({
    leftTitle,
    rightTitles,
    extendedStyles,
    showBorderBottom = true,
    includeRightAction = false,
    showExtraCol = false,
    extraColHeader,
}: OwnProps) => {
    const [styles] = useState(() => mergeWithCss(linesHeaderStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.wrapper} id="cartHeader" {...{ showBorderBottom, includeRightAction, showExtraCol }}>
            <StyledWrapper {...styles.itemDescription}>
                <Typography {...styles.titleText}>{translate(leftTitle || "")}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.priceUnit}>
                <Typography {...styles.titleText}>{translate(rightTitles?.[0] || "")}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.qty}>
                <Typography {...styles.titleText}>{translate(rightTitles?.[1] || "")}</Typography>
            </StyledWrapper>
            {showExtraCol && (
                <StyledWrapper {...styles.extraCol}>
                    <Typography {...styles.titleText}>{translate(extraColHeader || "")}</Typography>
                </StyledWrapper>
            )}
            <StyledWrapper {...styles.total} {...{ showExtraCol }}>
                <Typography {...styles.titleText}>{translate(rightTitles?.[2] || "")}</Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

LinesHeader.defaultProps = {
    leftTitle: translate("Item Description"),
    rightTitles: ["Price/Unit", "QTY", "Total"],
    showExtraCol: false,
};

export default LinesHeader;
